import React, { Component, useState } from "react";
import { useContext } from "react";
import { Helmet } from "react-helmet";
import { useEffect } from "react";
import { BsFillHeartFill } from "react-icons/bs";
import { MessageBox } from "./MessageBox";
import Slider from "react-slick";
import Toast from "react-bootstrap/Toast";
import Spinner from "react-bootstrap/Spinner";
import { SampleNextArrow } from "./Home";
import { SamplePrevArrow } from "./Home";

import axios from "axios";

import {
  Accordion,
  Row,
  Col,
  Table,
  Carousel,
  Badge,
  Nav,
  Button,
  Container,
} from "react-bootstrap";
import { Link } from "react-router-dom";

import { ProductsList } from "./ProductsList";
import ProductCard from "./ProductCard";
import CartContext from "./CartContext";
import { LoadSpinner } from "./LoadSpinner";
import CartView from "./CartView";
import { HomeMobile } from "./HomeMobile";
export class Qrcode extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount = () => {
    this.context.SetPortalMode("Qrcode");
  };

  render() {
    return (
      <>
        <HomeMobile></HomeMobile>
      </>
    );
  }
}
